import { Form } from 'react-bootstrap';
import InfoTooltip from '../../InfoTooltip';

interface Props {
  checkBoxLabel: string,
  onValueChange: (nextValue: { start: number, end: number }) => void,
  onCheckChange: (nextChecked: boolean) => void,
  value: undefined | {
    start: number,
    end: number,
  },
  infoTooltipText?: string,
}

const TimePeriodSelect = (props: Props) => {
  const {
    value,
    onValueChange,
    onCheckChange,
    checkBoxLabel,
    infoTooltipText,
  } = props;
  const { start, end } = value || {};
  return (
    <div className='frow mgr ac mgb8 mgl'>
      <div className='frow f1 ac'>
        <Form.Check
          type="checkbox"
          checked={!!value}
          onChange={(e) => onCheckChange(e.target.checked)}
          label={checkBoxLabel}
          inline
        />
      </div>
      <div className='frow f1 ac'>
        Od
        <Form.Control
          type="number"
          className="mgl mgr"
          min={0}
          max={23}
          value={start || ''}
          disabled={!value}
          onChange={(e) => {
            if (!value) {
              throw new Error('Value is not defined');
            }
            const nextStartHour = parseInt(e.target.value);
            onValueChange({
              ...value,
              start: nextStartHour,
            });
          }}
        />
      </div>
      <div className='frow f1 ac'>
        do
        <Form.Control
          width="48px"
          type="number"
          className="mgl mgr"
          min={1}
          max={24}
          value={end || ''}
          disabled={!value}
          onChange={(e) => {
            if (!value) {
              throw new Error('Value is not defined');
            }
            const nextEndHour = parseInt(e.target.value);
            onValueChange({
              ...value,
              end: nextEndHour,
            });
          }}
        />
      </div>
      {infoTooltipText && (
        <InfoTooltip
          className='mgr'
          text={infoTooltipText}
        />
      )}
    </div >
  );
};

export default TimePeriodSelect;
